export default "__VITE_ASSET__CVfLb6Sx__ 800w";